import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import {shape, arrayOf, number, bool, object, string, func} from 'prop-types';
import {Statistic, Table, Container, Grid, Menu, Icon} from 'semantic-ui-react';
import FailureDisplay from './FailureDisplay';
import {isNumber} from 'utils/DBUtils';
import {formatDateTime} from '../../utils';

const UserPointsPage = props => {
  if (props.isLoading) {
    return (
      <Container textAlign='center'>
        <Icon loading name='spinner' size='huge' />
      </Container>
    );
  }

  if (props.ajaxError) {
    return <FailureDisplay labelKey='userManagement.userDetail.panes.points.ajaxError' />;
  }

  const failedPointsTotals = ['points', 'lifetimePoints'].some(key => !isNumber(props.user[key]));

  return (
    <Fragment>
      {failedPointsTotals ? (
        <FailureDisplay labelKey='userManagement.userDetail.panes.points.lifetimePointsError' />
      ) : (
        <Statistic.Group widths={6}>
          <Container textAlign='center'>
            <Grid centered>
              <Grid.Column width={6} textAlign='center'>
                <Statistic>
                  <Statistic.Value>{props.user.points || 0}</Statistic.Value>
                  <Statistic.Label>
                    <FormattedMessage id='userManagement.userDetail.panes.points.points' />
                  </Statistic.Label>
                </Statistic>
              </Grid.Column>
              <Grid.Column width={1}></Grid.Column>
              <Grid.Column width={6} textAlign='center'>
                <Statistic>
                  <Statistic.Value>{props.user.lifetimePoints || 0}</Statistic.Value>
                  <Statistic.Label>
                    <FormattedMessage id='userManagement.userDetail.panes.points.lifetimePoints' />
                  </Statistic.Label>
                </Statistic>
              </Grid.Column>
            </Grid>
          </Container>
        </Statistic.Group>
      )}
      {props.user.pointHistory.length > 0 && (
        <Table striped celled>
          <Table.Header className='white-header'>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.points.id' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.points.amount' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.points.amountBonus' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.points.amountTotal' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.points.userLevel' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.points.reason' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.points.transactionType' />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <FormattedMessage id='userManagement.userDetail.panes.points.dateCreated' />
            </Table.HeaderCell>
            {props.canCancelPoints && <Table.HeaderCell></Table.HeaderCell>}
          </Table.Header>
          <Table.Body>
            {props.user.pointHistory.map(item => (
              <Table.Row key={item.id}>
                <Table.Cell>{item.id}</Table.Cell>
                <Table.Cell>{item.amount}</Table.Cell>
                <Table.Cell>{item.amountBonus}</Table.Cell>
                <Table.Cell>{item.amountTotal}</Table.Cell>
                <Table.Cell>{item.userLevel}</Table.Cell>
                <Table.Cell>{item.reason}</Table.Cell>
                <Table.Cell>{item.transactionType}</Table.Cell>
                <Table.Cell>{item.dateCreated ? formatDateTime(item.dateCreated) : ''}</Table.Cell>
                {props.canCancelPoints && (
                  <Table.Cell>
                    <div className='revoke-points'>
                      <Menu.Item
                        disabled={item.canceled}
                        onClick={item.canceled ? null : () => props.revokePoints(Number(item.id))}>
                        <FormattedMessage id='userManagement.userDetail.panes.points.cancel' />
                      </Menu.Item>
                    </div>
                  </Table.Cell>
                )}
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </Fragment>
  );
};

export const PointHistoryItemPropType = shape({
  amount: number.isRequired,
  amountBonus: number.isRequired,
  amountTotal: number.isRequired,
  canceled: bool.isRequired,
  dateCreated: object.isRequired,
  reason: string.isRequired,
  transactionType: string.isRequired,
});

UserPointsPage.propTypes = {
  canCancelPoints: bool.isRequired,
  revokePoints: func.isRequired,
  isLoading: bool.isRequired,
  ajaxError: object,
  user: shape({
    lifetimePoints: number.isRequired,
    pointHistory: arrayOf(PointHistoryItemPropType),
    points: number.isRequired
  })
};

export default UserPointsPage;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/tabPanes/UserPointsPage.jsx